import { gql } from '@generated/gql';

const energyQuoteDetailsFragment = gql(`
  fragment EnergyQuoteDetails on EnergyQuoteDetails {
    meterType
    electricityPaymentMethod
    gasPaymentMethod
    paymentOption
    predefinedConsumption
    electricityUsageDay
    electricityUsageNight
    electricityIndustryEstimateDay
    electricityIndustryEstimateNight
    gasIndustryEstimate
    gasUsage
    electricVehicleTariffExpressionOfInterest
  }
`);

const energyQuoteFragment = gql(`
  fragment EnergyQuote on EnergyQuote {
    name
    isSelected
    isEligible
    quoteType
    monthlyCost {
      currency
      value
    }
    annualEstimateCost {
      currency
      value
    }
    gas {
      annualCost {
        currency
        value
      }
      discounts {
        id
        description
        qualified
        qualificationMessage
        creditAppliesAfter
        creditFrequency
        credit {
          ... on AmountCredit {
            amount
          }
          ... on PercentageCredit {
            percentage
          }
        }
      }
      exitFees
      productSubtype
      meterType
      monthlyCost {
        currency
        value
      }
      name
      paymentMethod
      paymentOption
      predefinedConsumption
      quoteType
      standingCharge
      tariffEndDate
      unitRate1
      unitRate2
      usageDay
      usageNight
    }
    electricity {
      annualCost {
        currency
        value
      }
      discounts {
        id
        description
        qualified
        qualificationMessage
        creditAppliesAfter
        creditFrequency
        credit {
          ... on AmountCredit {
            amount
          }
          ... on PercentageCredit {
            percentage
          }
        }
      }
      exitFees
      productSubtype
      meterType
      monthlyCost {
        currency
        value
      }
      name
      paymentMethod
      paymentOption
      predefinedConsumption
      quoteType
      standingCharge
      tariffEndDate
      unitRate1
      unitRate2
      usageDay
      usageNight
    }
  }
`);

const energyBasketFragment = gql(`
  fragment EnergyBasket on BasketEnergy {
    fuelType
    details {
      ...EnergyQuoteDetails
    }
    selectedQuote {
      ...EnergyQuote
    }
  }
`);

const energyTariffs = gql(`
  query GetEnergyTariffs($basketId: ID!) {
    energyTariffs(basketId: $basketId) {
      tariffs {
        ...EnergyQuote
      }
      nextTariffs {
        ...EnergyQuote
      }
      secondNextTariffs {
        ...EnergyQuote
      }
    }
  }
`);

export {
  energyQuoteDetailsFragment,
  energyQuoteFragment,
  energyBasketFragment,
  energyTariffs,
};
